module.exports = __webpack_public_path__ + "img/famousbrands.07176a02.png";